import EasyCropImage from "./EasyCropImage";
export default EasyCropImage;
